import '@/commons/language.js';
import '@/commons/util.js';
import pgApi from '@/commons/api.js';
import pgCommon from '@/commons/common.js';
window.pgApi = pgApi;
window.pgCommon = pgCommon;
